import { Injectable } from '@angular/core';
import { HttpClientService } from '../lib/http/http-client.service';
@Injectable()
export class ProfileService {

  constructor(public http: HttpClientService) { }

  public GetProfileDetail(CommunityLotId:Number) {
    return this.http.get("/DashBoard/GetProfileDetail?CommunityLotId=" + CommunityLotId);
  }

  public ChangePassword(changePasswordModel:any){
    return this.http.post("/Account/ChangePassword",changePasswordModel);
  }
  public getBuyerContactType() {
    return this.http.get('/DashBoard/GetBuyerContactType');
  }
  public GetMobileProvideByCountryID(CountryID:number)
  {
    return this.http.get("/DashBoard/GetMobileProvideByCountryID?CountryID=" + CountryID);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/profile.service.ts